import { Button } from '@ahmdigital/ui';
import { compact } from 'lodash/fp';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import Disclaimer from '../disclaimer';
import scrollToElementWithId from '../../../../../../../../utils/scroll-to-element-with-id';

type NoBundleChosenViewProps = {
  isCondensed?: boolean;
};

const ButtonContainer = styled.div`
  flex: 1;
  text-align: right;
`;

const StyledButton = styled(Button)<{ $isCondensed: boolean }>`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    width: ${({ $isCondensed }) => ($isCondensed ? '100%' : 'auto')};
  }
`;

const NoBundleChosenView = ({ isCondensed = false }: NoBundleChosenViewProps) => {
  const handleButtonClick = useCallback(() => {
    scrollToElementWithId('bundles-section');
  }, []);

  return (
    <>
      <Disclaimer showRefineLink={!isCondensed} />
      <ButtonContainer>
        <StyledButton
          $isCondensed={isCondensed}
          variant={compact(['border', 'white', isCondensed && 'marginBottomSpacer11'])}
          onClick={handleButtonClick}
        >
          Choose bundles
        </StyledButton>
      </ButtonContainer>
    </>
  );
};

export default NoBundleChosenView;
